<template>
  <div class="email-list-wrap">
    <template-search-list :listApi="listApi"
                          :buttonOption="buttonOption"
                          :defaultSortBy="defaultSortBy"
                          :reload="reload"
                          :initialSearchFilter="initialSearchFilter"
                          :isRangeToday="true"
                          :rangeTodayField="'receivedAt'"
                          :selected="selected"
                          @select="setSelected"
                          @showDetail="showDetail">
    </template-search-list>

    <inbox-mail-detail :infoApi="infoApi"
                :apiParam="apiParam"
                @reload="reloadList"
                @close="setSelected">

    </inbox-mail-detail>
  </div>
</template>

<script>
import { getInbox, getInboxList } from '@/api/contact'

import TemplateSearchList from '@/components/_template/SearchList'
import InboxMailDetail from '@/components/contact/inbox/InboxMailDetail'
import { format } from 'date-fns'

export default {
  name: 'InboxMailList',
  components: {
    TemplateSearchList,
    InboxMailDetail
  },
  methods: {
    showDetail (data) {
      this.apiParam = { id: data._id, templateName: 'adminAi' }
    },
    reloadList () {
      this.reload++
    },
    setSelected (row) {
      this.selected = row
    }
  },
  created () {
    this.initialSearchFilter = {
      receivedAt: {
        start: format(new Date(), 'yyyy-MM-dd'),
        end: format(new Date(), 'yyyy-MM-dd'),
        itsEmailList: true
      }
    }
  },
  data () {
    return {
      reload: 0,
      apiParam: null,
      selected: null,

      infoApi: getInbox,
      listApi: getInboxList,
      buttonOption: [
        {
          action: 'showDetail',
          columnText: '자세히',
          buttonText: '<i class="xi-arrow-right"></i>'
        }
      ],
      defaultSortBy: '-receivedAt',
      initialSearchFilter: null
    }
  }
}
</script>

<style lang="scss" scoped>
.email-list-wrap {
}
</style>
